import '../LandingPage.css';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, provider } from '../firebase';
import { signInWithPopup } from 'firebase/auth';
import SiteService from './SiteService';
import FreeConsumptionStepper from './Rating/FreeConsumptionStepper';
import QRCode from 'react-qr-code';

const LandingPage = () => {
  const navigate = useNavigate();

  // ✅ Reklam sadece 3. step’e gelince açılır
  const [showAds, setShowAds] = useState(false);

  // SPA’de aynı reklamı tekrar render/push etmek için key
  const [adRenderKey, setAdRenderKey] = useState(0);

  // aynı key için ikinci kez push yapmamak için
  const hasPushedForKeyRef = useRef(new Set());

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const userData = {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        provider: 'google',
      };
      await SiteService.addUser(userData);
      navigate('/');
    } catch (error) {
      console.error('Google ile giriş yapılamadı:', error);
    }
  };

  // FreeConsumptionStepper 3. step’e geçtiğinde bunu çağıracak
  const handleUserEngaged = () => {
    setShowAds(true);
    setAdRenderKey((k) => k + 1);
  };

  // Reklam DOM'a render olduktan sonra push
  useEffect(() => {
    if (!showAds) return;

    if (hasPushedForKeyRef.current.has(adRenderKey)) return;

    const t = setTimeout(() => {
      try {
        window.adsbygoogle = window.adsbygoogle || [];
        window.adsbygoogle.push({});
        hasPushedForKeyRef.current.add(adRenderKey);
      } catch (e) {
        console.error('AdSense push error:', e);
      }
    }, 50);

    return () => clearTimeout(t);
  }, [showAds, adRenderKey]);

  return (
    <div className="landing-page">
      <div className="landing-content">
        <div className="text-center mb-5">
          <h1 className="fw-bold display-5">🔌 Süzme Sayaç Hesaplama</h1>
          <p className="lead text-muted">
            Elektrik faturasını süzme sayaçlara profesyonel hesaplama yöntemleri ile adil şekilde paylaştırın
          </p>
        </div>

        {/* ✅ 3. step’e gelince onUserEngaged tetiklenecek */}
        <FreeConsumptionStepper onUserEngaged={handleUserEngaged} />

        {/* ✅ Reklam sadece showAds true olunca görünür */}
        {showAds && (
          <section className="adsense-section" aria-label="Sponsorlu içerik">
            <div className="adsense-label">Sponsorlu</div>
            <ins
              key={adRenderKey}
              className="adsbygoogle adsense-landing"
              style={{ display: 'block' }}
              data-ad-client="ca-pub-7115067061462299"
              data-ad-slot="6411716550"
              data-ad-format="auto"
              data-full-width-responsive="true"
            />
          </section>
        )}

        {/* Bilgilendirici içerik */}
        <section className="mt-4 mb-5" aria-label="Süzme Sayaç Hakkında">
          <div className="p-4" style={{ background: '#f8fafc', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
            <h2 className="h5 fw-bold mb-3">Süzme sayaçla elektrik faturası nasıl paylaştırılır?</h2>
            <p className="text-muted mb-3" style={{ lineHeight: 1.65 }}>
              Elektrik faturanızı alt sayaçlara adilce paylaştırmanızı sağlar. Tüm EPDK tarifelerini destekler. Kademeli
              tarifelerde ucuz olan ilk kademeyi önce kimin kullanacağını seçebilirsiniz. Süzme sayaçlardan birisi fazla
              elektrik tükettiği için pahalı tarifeye geçilirse az tüketen süzme sayaç bundan etkilenmez. Özellikler: • Alt
              sayaç ekleme/düzenleme • Süzme Sayaç Önceliklendirme • Geç sayaç okuma durumunda otomatik orantı hesaplama •
              Fatura ve sayaç okuma yönetimi • Paylaştırma ve özet rapor • Kiracı, Hobi Bahçesi, İş yeri, Komşu tüketimini
              şeffaf yönetin
            </p>

            <h3 className="h6 fw-bold mb-2">Kademeli tarife ve çok zamanlı tarifelerde durum</h3>
            <p className="text-muted mb-3" style={{ lineHeight: 1.65 }}>
              Elektrik tarifelerinde kademeli (belirli eşiklere göre değişen birim fiyat) veya çok zamanlı (gündüz/puant/gece)
              yapı söz konusu olabilir. Bu tür tarifelerde herkesin tüketimi farklı aralıklara denk geldiği için basit oran
              hesabı adaletsiz sonuç verebilir. Süzme Sayaç Hesaplama aracı, tarife detaylarına göre hesaplamayı daha tutarlı
              şekilde yapmanıza yardımcı olur.
            </p>

            <h3 className="h6 fw-bold mb-2">Bu sayfayı kullanmak için ne yapmalıyım?</h3>
            <ul className="text-muted mb-0" style={{ lineHeight: 1.65 }}>
              <li>Faturadaki toplam tutarı ve ana sayaç tüketim bilgilerini girin.</li>
              <li>Süzme sayaçların tüketimlerini ekleyin.</li>
              <li>Hesapla diyerek paylaşımı görün. Daha gelişmiş özellikler için Google ile giriş yapabilirsiniz.</li>
            </ul>

            <div className="mt-3 text-muted small">
              <span>Destek: </span>
              <a href="https://suzmesayac.com/support" target="_blank" rel="noopener noreferrer">
                suzmesayac.com/support
              </a>
              <span className="mx-2">•</span>
              <span>Gizlilik: </span>
              <a href="https://suzmesayac.com/privacy" target="_blank" rel="noopener noreferrer">
                suzmesayac.com/privacy
              </a>
            </div>
          </div>
        </section>

        {/* Mobil uygulama duyurusu (senin kodun aynen) */}
        <div
          className="mobile-app-section text-center my-5 p-4"
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '16px',
            color: 'white',
          }}
        >
          <h3 className="mb-3">📱 Mobil Uygulamalarımız</h3>
          <p className="mb-4" style={{ fontSize: '1.1rem' }}>
            Süzme Sayaç uygulamasını artık cebinizde taşıyın!
            <br />
            Dilediğiniz zaman, dilediğiniz yerden hesaplama yapın.
          </p>

          <div className="d-flex justify-content-center align-items-center gap-4 flex-wrap mb-4">
            <a
              href="https://apps.apple.com/app/süzme-sayaç/id6751746732"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'inline-block' }}
            >
              <img
                src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/tr-tr?size=250x83&amp;releaseDate=1727913600"
                alt="App Store'dan İndir"
                style={{ height: '50px' }}
              />
            </a>

            <div style={{ position: 'relative', display: 'inline-block' }}>
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play'den İndir"
                style={{ height: '50px', opacity: 0.5, filter: 'grayscale(100%)' }}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  background: 'rgba(0,0,0,0.8)',
                  padding: '4px 12px',
                  borderRadius: '4px',
                  fontSize: '0.85rem',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                }}
              >
                ÇOK YAKINDA
              </div>
            </div>
          </div>

          <div className="mt-4 pt-4" style={{ borderTop: '1px solid rgba(255,255,255,0.3)' }}>
            <p className="mb-3" style={{ fontSize: '0.95rem' }}>
              📲 <strong>Mobil cihazınızdan QR kodu okutarak hızlıca indirin:</strong>
            </p>
            <div style={{ background: 'white', padding: '15px', borderRadius: '12px', display: 'inline-block' }}>
              <QRCode value="https://apps.apple.com/app/süzme-sayaç/id6751746732" size={150} level="H" />
            </div>
            <p className="mt-2" style={{ fontSize: '0.8rem', opacity: 0.9 }}>
              iOS için App Store'a yönlendirir
            </p>
          </div>

          <div className="mt-4">
            <small style={{ opacity: 0.9 }}>✨ Tüm verileriniz senkronize • 🔔 Bildirimler • 📊 Detaylı raporlar</small>
          </div>
        </div>

        <div className="text-center mt-5">
          <h5 className="mb-3">🔐 Giriş Yapın</h5>
          <p className="text-muted mb-3">
            Ana ve süzme sayaçlarınızı tanımlayıp aylık fatura paylaştırmak için Google hesabınızla giriş yapabilirsiniz.
          </p>
          <button className="btn btn-primary btn-lg" onClick={handleLogin}>
            Google ile Giriş Yap
          </button>
        </div>

        <footer className="text-center mt-5 text-muted small">
          <hr />
          <div className="mb-2">
            <a href="https://suzmesayac.com/support" target="_blank" rel="noopener noreferrer">
              Support
            </a>
            <span className="mx-2">•</span>
            <a href="https://suzmesayac.com/privacy" target="_blank" rel="noopener noreferrer">
              Privacy
            </a>
          </div>
          <div className="mb-2">Bu sayfada reklam gösterilebilir.</div>
          <p>Süzme Sayaç Uygulaması &copy; {new Date().getFullYear()} | info@suzmesayac.com</p>
        </footer>
      </div>
    </div>
  );
};

export default LandingPage;